import React, { useEffect, useState, useCallback } from 'react';
import InitialScreen from './components/InitialScreen.jsx';
import MissionScreen from './components/MissionScreen.jsx';
import GameScreen from './components/GameScreen.jsx';
import LoadingOverlay from './components/LoadingOverlay.jsx';
import ErrorDisplay from './components/ErrorDisplay.jsx';
import ToastMessage from './components/ToastMessage.jsx';
import OutcomeScreen from './components/OutcomeScreen.jsx';
import AlertModal from './components/AlertModal.jsx'; 
import './styles.css';

import { useGame } from './context/GameContext.jsx';

function App() {
  const { 
    setLang, 
    translations, 
    alertModalRef,   
    alertModalState,
    lang 
  } = useGame();

  const [currentHashPage, setCurrentHashPage] = useState(() => {
    const hash = window.location.hash.substring(1);
    return hash || 'initial';
  });

  useEffect(() => {
    const storedLang = localStorage.getItem('language');
    if (storedLang && translations[storedLang]) {
      setLang(storedLang);
    }
  }, [setLang, translations]); 

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      setCurrentHashPage(hash || 'initial');
      console.log(`App.jsx: Hash changed to: ${hash || 'initial'}`);
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [translations, lang]);

  const renderScreen = useCallback(() => {
    switch (currentHashPage) {
      case 'mission':
        return <MissionScreen />;
      case 'game':
        return <GameScreen />;
      case 'outcome':
        return <OutcomeScreen />;
      case 'initial':
      default:
        return <InitialScreen />;
    }
  }, [currentHashPage]);

  return (
    <div className="container">
      <LoadingOverlay />
      <ErrorDisplay />
      <ToastMessage />

      {renderScreen()}

      <AlertModal
        ref={alertModalRef}
        title={alertModalState.title}
        message={alertModalState.message}
        isConfirmation={alertModalState.isConfirmation}
        onConfirm={alertModalState.onConfirm}
        onClose={alertModalState.onClose}
        confirmButtonText={alertModalState.confirmButtonText}
        cancelButtonText={alertModalState.cancelButtonText}
      />
    </div>
  );
}

export default App;